export const configuration = window?.APP_CONFIG?.MLC_ENV
    ? Object.freeze({
          env: window.APP_CONFIG.MLC_ENV,
          api: window.APP_CONFIG.API_PROTO + '://' + window.APP_CONFIG.API_HOST + '/api',
          simple: window.APP_CONFIG.API_PROTO + '://' + window.APP_CONFIG.API_HOST,
          api2v: window.APP_CONFIG.API_2V_PROTO + '://' + window.APP_CONFIG.API_2V_HOST + '/api2v',
          datadog_app_id: window.APP_CONFIG.DATADOG_APPLICATION_ID,
          datadog_client_token: window.APP_CONFIG.DATADOG_CLIENT_TOKEN,
      })
    : Object.freeze({
          env: 'test',
          api: 'http://localhost:8000/api',
          simple: 'http://localhost:8000',
          api2v: 'http://localhost:8001/api2v',
          datadog_app_id: '',
          datadog_client_token: '',
      })
